export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 1_00.2af8ee61.jpg";